export const TYPE = 'release'
export const API_ROOT = {
  debug: 'https://api-dev.drlin.compassbioinfo.com/',
  release: 'https://server.gvss-inherinext.compassbioinfo.com/'
}[TYPE]



// WEBPACK FOOTER //
// ./src/api/config.js